import {useMemo, useState} from 'react';
import _ from 'lodash';
import {parseDate} from '../lib/utilities';

export const usePagination = (initialData, filters, pageOptions) => {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(pageOptions[0]);
  const [sortConfig, setSortConfig] = useState({key: null, direction: 'asc'});

  const filteredData = useMemo(() => {
    return _.filter(initialData, (item) => {
      const senderMatch = filters.sender ? item.sender?.toLowerCase().includes(filters.sender.toLowerCase()) : true;
      const receiverMatch = filters.receiver
        ? item.receiver?.toLowerCase().includes(filters.receiver.toLowerCase())
        : true;
      return senderMatch && receiverMatch;
    });
  }, [initialData, filters]);

  const slicedData = useMemo(() => {
    const sortedData = sortConfig.key
      ? _.orderBy(
          filteredData,
          [
            (item) => {
              const value = item[sortConfig.key];
              if (sortConfig.key === 'date') {
                return parseDate(value);
              }
              return value?.toString().toLowerCase();
            },
          ],
          [sortConfig.direction]
        )
      : filteredData;

    return _.slice(sortedData, page * rowsPerPage, (page + 1) * rowsPerPage);
  }, [filteredData, sortConfig, page, rowsPerPage]);

  const MemoizedEmptyRows = useMemo(() => {
    if (filteredData.length === 0) return 0;
    return page > 0 ? Math.max(0, (1 + page) * rowsPerPage - filteredData.length) : 0;
  }, [filteredData, page, rowsPerPage]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    const newRowsPerPage = parseInt(event.target.value, 10);
    const startIndex = page * rowsPerPage;
    const newPage = Math.floor(startIndex / newRowsPerPage);
    setRowsPerPage(newRowsPerPage);
    setPage(newPage);
  };

  const handleSort = (column) => {
    const direction = sortConfig.key === column && sortConfig.direction === 'asc' ? 'desc' : 'asc';
    setSortConfig({key: column, direction});
  };

  return {
    page,
    setPage,
    rowsPerPage,
    pageOptions,
    slicedData,
    MemoizedEmptyRows,
    handleChangePage,
    handleChangeRowsPerPage,
    handleSort,
    sortConfig,
  };
};
